import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_ACCOUNT_DETAIL', data);
};

export default {
  async SEARCH_GRID_ACCOUNT_DETAIL(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/detail-list?${StringUtil.queryStringfy(param)}`);

    setGridData(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/detail/accountDetailAction.js